import React, {useRef} from 'react';
import useCloseOnBlur from '../../../customHooks/useCloseOnBlur';
import styles from './DropdownLayout.module.scss';

function DropdownLayout({trigger, content, isOpen, onClose, className, ...other}) {
  const ref = useRef(null);
  useCloseOnBlur(ref, onClose);

  return (
    <div className={`${styles.dropdown} ${className ? className : ''}`} {...other} ref={ref}>
      {trigger}
      {isOpen && (
        <div className={styles.dropdownContent}>
          {content}
        </div>
      )}
    </div>
  );
}

export default DropdownLayout;
